// Legacy utils - deprecated, use useSnackbar hook instead
// This file is kept for backward compatibility during migration
// TODO: Remove this file once all components are updated to use useSnackbar

let snackbarRef = null;

export const setSnackbarRef = (ref) => {
  snackbarRef = ref;
};

export const snackbarUtils = {
  showMessage: (message, severity = null) => {
    if (snackbarRef) {
      snackbarRef.showMessage(message, severity);
    } else {
      console.warn("Snackbar not initialized. Use useSnackbar hook instead.");
    }
  },

  showSuccess: (message) => {
    if (snackbarRef) {
      snackbarRef.showSuccess(message);
    }
  },

  showError: (message) => {
    if (snackbarRef) {
      snackbarRef.showError(message);
    }
  },

  showWarning: (message) => {
    if (snackbarRef) {
      snackbarRef.showWarning(message);
    }
  },

  showInfo: (message) => {
    if (snackbarRef) {
      snackbarRef.showInfo(message);
    }
  },

  close: () => {
    if (snackbarRef) {
      snackbarRef.close();
    }
  },

  handleClose: (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    if (snackbarRef) {
      snackbarRef.handleClose(event, reason);
    }
  },
};
